import React from 'react';
import { Control, Controller } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';
import WithPaper from 'common/hocs/WithPaper';
import Checkbox from 'common/components/Checkbox';
import { BILLING_ADDRESS, DIFFERENT_DATA, PAYER_ADDRESS } from '../../../common/constants';

type Props = {
    control: Control;
    differentData: boolean;
    setCheckoutValues: Function;
    setDifferentData: Function;
};

const DifferentData: React.FC<Props> = ({
    control,
    differentData,
    setCheckoutValues,
    setDifferentData,
}) => {
    const handleChange = ([e]: any | EventTarget) => {
        const { getValues } = control;

        const checked = e.target.checked;
        const values = getValues({ nest: true });

        let payerAddressData = {};

        if (!checked) payerAddressData = values[BILLING_ADDRESS];

        setCheckoutValues({ [PAYER_ADDRESS]: payerAddressData });
        setDifferentData(checked);

        return checked;
    };

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Grid item xs={12}>
                <Box alignItems="center" display="flex" ml={1.8}>
                    <Controller
                        as={<Checkbox />}
                        control={control}
                        checked={differentData}
                        id="different_data"
                        name={DIFFERENT_DATA}
                        onChange={handleChange}
                        defaultValue={differentData}
                    />
                    <FormLabel htmlFor="different_data">
                        Dane płatnika są inne niż dane na fakturze
                    </FormLabel>
                </Box>
            </Grid>
        </Grid>
    );
};

export default WithPaper(null)(DifferentData);
